/**
 * Browser polyfills for Node.js globals.
 *
 * simple-peer uses readable-stream which references `process`, `global`, and `Buffer`.
 * Webpack 5 (CRA 5) no longer auto-polyfills these — we shim them here.
 *
 * This file MUST be the first import in index.js so it runs before any
 * module that transitively requires these globals.
 */

// eslint-disable-next-line no-undef
window.global = window.global || window;

window.process = window.process || {
  env: { NODE_ENV: 'production' },
  browser: true,
  version: '',
  versions: {},
  nextTick(fn, ...args) {
    setTimeout(() => fn(...args), 0);
  },
};

// Ensure process.env exists even if process was already partially defined
if (!window.process.env) {
  window.process.env = { NODE_ENV: 'production' };
}
if (typeof window.process.nextTick !== 'function') {
  window.process.nextTick = function(fn, ...args) { setTimeout(() => fn(...args), 0); };
}
window.process.browser = true;

/**
 * Suppress readable-stream / simple-peer async cleanup errors.
 *
 * When simple-peer is destroyed during React unmount, readable-stream's
 * queueMicrotask callbacks (updateReadableListening, emitReadable_) fire
 * after `self` is already torn down, crashing on `self._readableState`.
 *
 * CRA's error overlay installs bubble-phase handlers. We use the CAPTURE
 * phase (useCapture=true) so our handler fires first and can stop
 * propagation before CRA ever sees the error.
 *
 * window.onerror is also patched in public/index.html (earliest possible)
 * as the primary defence. This is the secondary defence inside the bundle.
 */
function _isReadableStreamError(msg) {
  if (!msg) return false;
  return (
    msg.includes('_readableState') ||
    msg.includes('_writableState') ||
    msg.includes('updateReadableListening') ||
    msg.includes('emitReadable')
  );
}

window.addEventListener('error', (event) => {
  if (_isReadableStreamError(event?.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true /* capture phase — fires before CRA overlay handler */);

window.addEventListener('unhandledrejection', (event) => {
  if (_isReadableStreamError(event?.reason?.message)) {
    event.preventDefault();
  }
}, true);

